<template>
  <DetailDialog
    title="アラート"
    icon="mdi-clock-alert-outline"
    :width="760"
    max-height="calc(100vh - 96px)"
    :is-saving="isSaving"
    @cancel="$emit('cancel')"
    @save="save"
  >
    <section class="detail-section">
      <h3>アラート</h3>
      <div class="alert-detail-grid">
        <div class="field-block">
          <span class="field-label">発生日時</span>
          <span class="field-value">{{ alertSupport.alertedAt }}</span>
        </div>
        <div class="field-block alert-type-block">
          <span class="field-label">種別</span>
          <span class="field-value">{{ alertSupport.alertType }}</span>
          <v-btn
            class="karte-button"
            color="#3ACAC9"
            variant="outlined"
            size="x-small"
            @click="$emit('open-karte', alertSupport)"
          >
            相談カルテを開く
          </v-btn>
        </div>
        <div class="field-block note-block">
          <span class="field-label">相談員からの補足</span>
          <textarea
            class="readonly-note"
            :value="alertSupport.alertNote"
            readonly
          />
        </div>
      </div>
    </section>

    <section class="detail-section policy-section">
      <h3>対応方針</h3>
      <div class="policy-detail-grid">
        <div class="field-block policy-options-block">
          <span class="field-label">対応方針</span>
          <label
            v-for="option in policyOptions"
            :key="option.value"
            class="policy-option"
          >
            <input
              v-model="selectedPolicy"
              type="radio"
              name="high-risk-alert-support-policy"
              :value="option.value"
            >
            <span>{{ option.label }}</span>
          </label>
        </div>
        <div class="field-block policy-note-block">
          <span class="field-label">補足</span>
          <textarea
            v-model="policyNote"
            class="editable-note"
          />
        </div>
      </div>
    </section>
  </DetailDialog>
</template>

<script>
import DetailDialog from "@/vue/shared/ui/DetailDialog.vue";

// 対応方針の選択肢。値は high_risk_alerts.response_policy の整数コードに対応。
// 未定(0)はラジオ未選択状態として扱うため、選択肢は 1〜7 を提示する。
const policyOptions = [
  { value: 1, label: "経過観察" },
  { value: 2, label: "同意があれば自治体連携" },
  { value: 3, label: "同意がなくても自治体連携" },
  { value: 4, label: "同意確認せずに自治体連携" },
  { value: 5, label: "頻回対応" },
  { value: 6, label: "ハイリスク・頻回以外" },
  { value: 7, label: "他のアラートで対応" }
];

export default {
  name: "FaceSheetHighRiskAlertSupportDetailWindow",
  components: {
    DetailDialog
  },
  props: {
    alertSupport: {
      type: Object,
      required: true
    },
    // 保存処理中フラグ。true の間は保存ボタンを無効化し連打を防ぐ。
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  emits: ["cancel", "open-karte", "save"],
  data() {
    return {
      policyOptions,
      selectedPolicy: null,
      policyNote: ""
    };
  },
  watch: {
    alertSupport: {
      handler(alertSupport) {
        this.selectedPolicy = alertSupport?.responsePolicy ?? null;
        this.policyNote = alertSupport?.policyNote || "";
      },
      immediate: true
    }
  },
  methods: {
    save() {
      this.$emit("save", {
        id: this.alertSupport?.id,
        lockVersion: this.alertSupport?.lockVersion,
        response_policy: this.selectedPolicy ?? 0,
        response_note: this.policyNote
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-section {
  border-bottom: 1px solid #eeeeee;
  padding: 14px 20px 22px;
}

.detail-section:last-child {
  border-bottom: none;
}

.detail-section h3 {
  color: rgba(0, 0, 0, 0.82);
  font-size: 13px;
  font-weight: 700;
  margin: 0 0 14px;
}

.alert-detail-grid,
.policy-detail-grid {
  display: grid;
  gap: 28px;
  grid-template-columns: 140px 140px 1fr;
}

.policy-detail-grid {
  grid-template-columns: 190px 1fr;
}

.policy-option {
  align-items: center;
  color: rgba(0, 0, 0, 0.76);
  display: flex;
  font-size: 12px;
  gap: 4px;
  line-height: 1.45;
}

.alert-type-block {
  align-items: flex-start;
}

.karte-button {
  margin-top: 4px;
}

.note-block {
  min-width: 0;
}

.policy-section {
  padding-bottom: 24px;
}

.policy-options-block {
  gap: 2px;
}

.policy-option input {
  height: 13px;
  margin: 0;
  width: 13px;
}

.policy-note-block {
  min-width: 0;
}

@media (max-width: 720px) {
  .alert-detail-grid,
  .policy-detail-grid {
    gap: 16px;
    grid-template-columns: 1fr;
  }
}
</style>